export const CREATE_WITHDRAWAL = "CREATE_WITHDRAWAL";
export const CREATE_WITHDRAWAL_SUCCESS = "CREATE_WITHDRAWAL_SUCCESS";
export const CREATE_WITHDRAWAL_FAILURE = "CREATE_WITHDRAWAL_FAILURE";

export const GET_WITHDRAWALS = "GET_WITHDRAWALS";
export const GET_WITHDRAWALS_SUCCESS = "GET_WITHDRAWALS_SUCCESS";
export const GET_WITHDRAWALS_FAILURE = "GET_WITHDRAWALS_FAILURE";
